export default function LoadingExportarFinanceiro() {
  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-4 py-6">
      <div className="h-9 w-64 animate-pulse rounded-lg bg-slate-200" />
      <div className="animate-pulse rounded-xl border border-slate-200 bg-white p-6">
        <div className="h-6 w-48 rounded bg-slate-100" />
        <div className="mt-4 grid grid-cols-3 gap-3">
          <div className="h-16 rounded-lg bg-slate-100" />
          <div className="h-16 rounded-lg bg-slate-100" />
          <div className="h-16 rounded-lg bg-slate-100" />
        </div>
        <div className="mt-4 h-40 rounded-lg bg-slate-100" />
        <div className="mt-4 h-40 rounded-lg bg-slate-100" />
      </div>
    </div>
  );
}
